module.exports = __webpack_public_path__ + "img/line.f0584936.jpg";